import {
  listAll,
  IListAllParameters,
  IListAllResponseOK,
  IEventOrChallengeOrMilestone,
} from '@ifit/gateway-achievement-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';

export function useMilestone(year = new Date().getFullYear()): UseQueryResult<IListAllResponseOK, Error> {
  const parameters: IListAllParameters = {
    type: IEventOrChallengeOrMilestone.Milestone,
    perPage: 1000,
    page: 1,
  };

  return useQuery<IListAllResponseOK, Error>(
    ['use-milestone', { year }],
    () =>
      listAll({ ...parameters }).then((data) =>
        data.filter(({ milestoneYear }) => milestoneYear === year).sort((a, b) => a.milestoneCount - b.milestoneCount)
      ),
    {
      staleTime: FIFTEEN_SECONDS,
      cacheTime: ONE_DAY,
    }
  );
}
